<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div v-for="item in classes" v-bind:key="item.Id">
              <div v-if="item.id == scheduleId">
                <h4 style="color: #000; text-align: left" class="custom-user-name">
                  Meeting ID
                </h4>
                <form class="ml-3 mr-3">
                  <input
                    type="text"
                    class="custom-input-user"
                    placeholder="Meeting ID"
                    v-model="item.meetingId"
                  />
                  <input type="hidden" v-model="item.start" />
                  <!-- <input type="hidden" v-model="item.end" /> -->
                </form>

                <br />

                <h4 style="color: #000; text-align: left" class="custom-user-name">
                  Meeting Password
                </h4>
                <form class="ml-3 mr-3">
                  <input
                    type="text"
                    class="custom-input-user"
                    placeholder="Meeting Password"
                    v-model="item.password"
                  />
                </form>
                
                <br />

                <h4 style="color: #000; text-align: left" class="custom-user-name">
                  Class Link
                </h4>
                <form class="ml-3 mr-3">
                  <input
                    type="text"
                    class="custom-input-user"
                    placeholder="Class Link"
                    v-model="item.joinLink"
                  />
                </form>

                <CButton  style="
                position: fixed;
                bottom: 30px;
                left: 0px;
                right: 0px;
                text-align: center;
                margin: 0 auto;
                " color="info" class="btn-select-blue mt-5" @click="SubmitSchedule(item.start, item.meetingId, item.password, item.joinLink)">
                Save
                </CButton>

              </div>
            </div>


          </div>          
        </div>
      </div>      
    </CContainer>

    <div class="header-top">Jobs</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>

    <div style="clear: both"></div>

  </div>

</template>

<script>
import Vue from "vue";
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(require("vue-moment"));
import moment from "moment";

import Datepicker from 'vuejs-datepicker';

export default {
  components: {
     Calendar,
     Datepicker,
  },
  data: function () {
    return {
      user: {},
      classes: [],
      detail: {},

      scheduleDetail: true,
      SelectDay: false,
      SelectTime: false,
      classLink: false,
        RejectJob: false,

        selectedDay: "",
        selectedTime: "",
        meetingId: "",
        meetingPassword: "",
        classLink: "",
      scheduleId: this.$route.query.scheduleId,
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetTimeTableTeacher(this.user.id);
            this.GetTeacherId(this.user.id);
            this.GetHour();
            // this.GetNotificationTeacher(this.user.id);
            // this.GetConfirmationClass(this.$route.query.notiId);
            
          }
        });
    },

    GetTeacherId() {
      this.$API
        .get(this.$SelectTeacherId + "?userId=" + this.user.id, {})
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teaid = response.data;
            console.log("teacherid", this.teaid);
          }
        });
    },

    GetTimeTableTeacher() {
      this.$API
        .get(this.$ScheduleTeacherWeb + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });
    },

    GoBack() {
      this.$router.back();
    },

    OpenDetail(findTutorId) {
      this.$API
        .get(this.$FindTutorDetailsById + "?findtutorId=" + findTutorId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.details = response.data;
          }
        });

      this.DetailClass = true;
    },

    GetScheduleDetail(findTutorId) {
      this.$API
        .get(this.$FindTutorDetailsById + "?findtutorId=" + findTutorId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.detail = response.data;
          }
        });

      this.DetailClassRespond = true;
    },

    OpenDetailComplete(scheduleId) {
      this.selectedClass = scheduleId;
      this.DetailClassHistory = true;
    },

    OpenAccept() {
      const formData = new FormData();

      formData.append("FindTutorId", this.details.findTutorId);
      formData.append("TeacherId", this.teaid.teacherId);

      return this.$API
      .post( this.$TeacherConfirmClass, formData, {
        withCredentials: true
      })
      .then(response => {
        if (response.status == 200 && response.data != null) {
          this.GoToPageTutorJobAccept();
        }
      })
      .catch(error => {
        if (error.response) {
          console.log(error.response.status);
          this.Error = true;
          this.Message = error;
          this.Message = "Error";
        }
      }); 
    },

    selectTime(name){
       this.selectedTime = name;
    },

    SubmitSchedule: function (start, meetingId, password, joinLink) {
      const formData = new FormData();

      //var Date = moment(this.selectedDay).format('YYYY-MM-DD');
      // var Time = moment(this.selectedTime).format('hh:mm:ss');
      var date = moment(start).format('YYYY-MM-DD');
      var time = moment(start).format('hh:mm:ss');

      formData.append("scheduleId", this.scheduleId);
      formData.append("dates", date);
      formData.append("times", time);
      formData.append("vcLink", joinLink);
      formData.append("meetingId", meetingId);
      formData.append("password", password);
      

      return this.$API
        .post(this.$TutorEditSchedule, formData, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if(response.status == 200 && response.data != null) {
            this.Message = response.data.Message;
            this.SuccessMessage = true;
            this.GoToAllSet();
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });
    },

    GoToSummarySchedule(){
      this.scheduleDetail = false;
      // this.day = day;
      // this.time = time;
    },

    GoToClassLink(scheduleId) {
      this.$router.push("EditClassLink" + scheduleId);
      // this.scheduleDetail = false;
      // this.classLink = true;
    },

    GoToAllSet() {
      this.$router.push("TutorJobAccept");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");


.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="radio"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}

</style>